import { render, staticRenderFns } from "./ListItems01Edit.vue?vue&type=template&id=6fad224d&"
import script from "./ListItems01Edit.vue?vue&type=script&lang=js&"
export * from "./ListItems01Edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports